import _ from 'lodash';

// abbreviateNumber ...
export function abbreviateNumber(value: number) {
  let newValue = value;
  const suffixes = ['', 'K', 'M', 'B', 'T'];
  let suffixNum = 0;
  if (value < 1000) {
    return `${value}`;
  }
  while (newValue >= 1000) {
    newValue /= 1000;
    suffixNum += 1;
  }
  newValue = _.round(newValue, 1);
  return `${newValue}${suffixes[suffixNum]}`;
}

// numberWithCommas ...
export const numberWithCommas = (x: number) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
